<template>
    <div>
        <div class="calls-list d-flex flex-column mr-md-2">
            <div class="calls-header px-3 py-3">{{type.replace("_", " ")}}:</div>
            <!-- list CFSs  -->
            <div class="my-2" v-if="typeFilter && !loadingCFPs && cfp.length">
                <div v-for="event in cfp" :key="event.slug" class="d-flex flex-column w-100 px-3">
                    <div class="d-flex">
                        <div class="pr-3">
                            <div class="cfs-name">{{event.name}}</div>
                            <div class="cfs-organizer">
                                <small>by {{event.organizer_name}}</small>
                            </div>
                            <div v-if="event.type==='meetup'" class="text-muted location">
                                <small class="d-flex align-items-center">
                                    <i class="material-icons mr-1">room</i>
                                    <div>{{event.location_city}}, {{event.location_country}}</div>
                                </small>
                            </div>
                            <div class="cfp-closes d-flex align-items-center" v-if="event.cfp">
                                <small class="txt-cfs-closes d-flex align-items-center">
                                    <i class="material-icons mr-1">access_time</i>
                                    <div>CFS closes in {{getCloseDateDistance(event.cfp.end_datetime.$date.$numberLong)}}</div>
                                </small>
                            </div>
                        </div>
                        <div class="ml-auto">
                            <md-button
                                class="md-icon-button md-list-action"
                                target="_blank"
                                :href="`//events.codemotion.com/call-for-speakers/${event.cfp.slug}`"
                            >
                                <md-icon class="md-primary" md-src="/img/cfs-page2.svg"></md-icon>
                            </md-button>
                        </div>
                    </div>
                    <hr class="separator my-2" />
                </div>
            </div>
            <!-- end -->
            <div
                v-else-if="type === 'submitted_to' && !loadingCFPs && proposals.length"
                class="my-2"
            >
                <div
                    v-for="(proposal, index) in proposals"
                    :key="proposal.id"
                    class="d-flex flex-column w-100 px-3"
                >
                    <div class="d-flex">
                        <div v-if="proposal.event_name">
                            <div class="cfs-name">{{proposal.event_name}}</div>
                            <div class="cfs-organizer">
                                <small>by {{proposal.organizer_name}}</small>
                            </div>
                            <div class="cfp-closes mt-2 d-flex align-items-start flex-column">
                                <paper-status :status="proposal.state"></paper-status>
                                <small
                                    class="txt-cfs-closes d-flex align-items-center mt-1"
                                    v-if="proposal.state !== 'APPROVED' && proposal.cfp"
                                >
                                    <i class="material-icons mr-1">access_time</i>
                                    <div>CFS closes in {{getCloseDateDistance(proposal.cfp.end_datetime.$date.$numberLong)}}</div>
                                </small>
                            </div>
                        </div>
                        <div class="ml-auto" v-if="proposal.cfp">
                            <md-button
                                class="md-icon-button md-list-action"
                                target="_blank"
                                @click="openProposalInfo(proposal)"
                            >
                                <i class="material-icons-outlined">info</i>
                            </md-button>
                        </div>
                    </div>
                    <hr class="separator my-2" v-if="proposals.length - 1 > index" />
                </div>
            </div>
            <div class="d-flex justify-content-center p-3" v-else-if="loadingCFPs">
                <b-spinner></b-spinner>
            </div>
            <div
                v-else-if="type === 'submitted_to' && !proposals.length"
                class="text-center text-muted h5 px-4 notify-txt-size my-3"
            >You didn't submit this paper to any Call for Speakers.</div>
            <div
                v-else-if="!cfp.length"
                class="text-center text-muted h5 px-4 notify-txt-size my-3"
            >Currently there are no open Calls for Speakers for this type of event.</div>
            <div v-if="cfp.length" class="d-flex justify-content-center mb-3">
                <a target="_blank" href="//events.codemotion.com/?cfp=true">
                    <button class="btn btn-sm btn-outline-success px-4 px-md-4">View all CFS</button>
                </a>
            </div>
        </div>
        <paper-info-modal
            :key="modalKey"
            v-model="paperDetails"
            :currentPaper="currentPaper"
            :isSpeaker="true"
        ></paper-info-modal>
    </div>
</template>

<script>
import { parseISO, formatDistanceToNow, format } from "date-fns";
import CodeMessage from "@/components/CodeMessage.vue";
import PaperStatus from "@/components/Papers/PaperStatus.vue";
import PaperInfoModal from "@/components/Papers/PaperInfoModal.vue";
export default {
    name: "ListCfs",
    data: () => ({
        loadingCFPs: false,
        cfp: [],
        proposals: [],
        currentPaper: null,
        paperDetails: false,
        modalKey: 0
    }),
    props: {
        type: {
            validator: val =>
                ["meetups", "conferences", "submitted_to"].indexOf(val) !== -1
        }
    },
    components: {
        CodeMessage,
        PaperStatus,
        PaperInfoModal
    },
    computed: {
        typeFilter() {
            switch (this.type) {
                case "meetups":
                    return {
                        cfp: {
                            from_datetime: format(
                                new Date(),
                                "yyyy-MM-dd HH:mm:ss"
                            )
                        },
                        type: "meetup"
                    };
                case "conferences":
                    return {
                        cfp: {
                            from_datetime: format(
                                new Date(),
                                "yyyy-MM-dd HH:mm:ss"
                            )
                        },
                        type: "conference"
                    };
                case "submitted_to":
                    return false;
            }
        }
    },
    methods: {
        openProposalInfo(paper) {
            this.currentPaper = paper;
            this.modalKey++;
            this.paperDetails = true;
        },
        async loadCFPs() {
            this.loadingCFPs = true;
            try {
                if (this.typeFilter) {
                    const eventsData = await this.$eventsApi.eventsList(
                        this.typeFilter
                    );
                    this.cfp = eventsData.data;
                } else {
                    const proposals = await this.$cfpApi.getUserProposals({
                        options: { paper_ids: [this.$route.params.paperId] },
                        per_page: 50
                    });
                    this.proposals = proposals.data;
                    let eventsData;
                    try {
                        eventsData = await this.$eventsApi.eventsList({
                            ids: [
                                ...new Set(
                                    this.proposals.map(el => el.event_id)
                                )
                            ]
                        });
                    } catch (error) {
                        console.error(error);
                        return;
                    }
                    this.proposals.forEach(proposal => {
                        const eName = eventsData.data.find(
                            event => event.uuid === proposal.event_id
                        );
                        proposal["event_name"] = eName ? eName.name : "";
                        proposal["organizer_name"] = eName ? eName.organizer_name : "";
                        proposal["cfp"] = eName ? { ...eName.cfp } : undefined;
                    });
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loadingCFPs = false;
            }
        },
        getCloseDateDistance(close) {
            close = new Date(parseInt(close));
            return formatDistanceToNow(close);
        }
    },

    async mounted() {
        this.loadCFPs();
    }
};
</script>

<style lang="scss">
.calls-list {
    .md-button.md-theme-default {
        background-color: #f8f8f8;
    }
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
//Tab  CFS mettups
.calls-list {
    box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
    border-radius: 5px;
    position: relative;
    background-color: #fff;
    .cfs-name {
        color: $palette-blue;
        font-weight: 500;
    }
    .cfs-organizer {
        margin-top: -5px;
        margin-bottom: 5px;
    }
    .calls-header {
        position: relative;
        font-weight: 600;
        width: 100%;
        text-transform: capitalize;
        border-bottom: 1px solid #f0f0f0;
    }
    .location {
        i {
            font-size: 15px;
            color: #757575;
        }
        small {
            font-size: 14px;
        }
    }
    .cfp-closes {
        i {
            font-size: 15px;
            color: #4f8d0a;
        }
        .txt-cfs-closes {
            color: #4f8d0a;
        }
    }
    .link-call:hover {
        .cfs-name {
            color: $palette-orange;
            font-weight: 500;
        }
    }

    .notify-txt-size {
        font-size: 15px;
    }

    .status {
        span {
            color: white;
            padding: 3px 8px;
            font-size: 12px;
            border-radius: 4px;
            font-weight: 600;
        }
        .pending {
            background: #a5a5a5;
        }
        .approved {
            background: #7ed321;
        }
        .draft {
            color: #a5a5a5;
            border: 1px solid #a5a5a5;
        }
        .rejected {
            background: red;
        }
    }

    .link-cta {
        font-size: 14px;
        -webkit-transition: color 0.5s ease;
        transition: color 0.5s ease;
    }

    .separator {
        border-top: 1px solid rgba(240, 240, 240, 1);
        width: 100%;
    }
}
</style>